import { Component, Inject, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductV2 } from '@banyan/commons/models/order/product.model';
import { AdminService } from '@banyan/modules/admin/services/admin.service';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-admin-request-detail-modal',
  templateUrl: './admin-request-detail-modal.component.html',
  styleUrls: ['./admin-request-detail-modal.component.scss'],
})
export class AdminRequestDetailModalComponent implements OnInit, OnDestroy {
  adminService = inject(AdminService);
  searchControl = new FormControl('');
  destroy = new Subject<void>();
  selectedProducts: ProductV2[] = [];

  constructor(
    public dialogRef: MatDialogRef<AdminRequestDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.adminService.searchedProducts.set([]);
  }

  ngOnInit(): void {
    this.handleSearch();
  }

  handleSearch(): void {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroy)
      )
      .subscribe((query) => {
        if (!query) {
          this.adminService.searchedProducts.set([]);
        } else {
          this.adminService.isLoadingProducts.set(true);
          this.adminService.searchProducts(query);
        }
      });
  }

  get productList(): ProductV2[] {
    return this.adminService.searchedProducts() ?? [];
  }

  toggleProductSelection(product: ProductV2): void {
    const index = this.selectedProducts.findIndex((p) => p.bigCommerceProductId === product.bigCommerceProductId);
    if (index > -1) {
      this.selectedProducts = this.selectedProducts.filter((p) => p.bigCommerceProductId !== product.bigCommerceProductId);
    } else if (this.selectedProducts.length < this.adminService.MAX_SELECTED_PRODUCTS) {
      this.selectedProducts = [...this.selectedProducts, product];
    }
  }

  isMaxProductsSelected(): boolean {
    return (this.selectedProducts.length + this.adminService.selectedProducts().length) >= this.adminService.MAX_SELECTED_PRODUCTS;
  }

  isSelected(product: ProductV2): boolean {
    return this.selectedProducts.some((p) => p.bigCommerceProductId === product.bigCommerceProductId);
  }

  isSelectedProduct(product: ProductV2): boolean {
    return this.adminService.selectedProducts().some((p) => p.bigCommerceProductId === product.bigCommerceProductId);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  addProducts(): void {
    this.adminService.checkAddedProducts(this.selectedProducts);
    this.closeModal();
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}